<template>
  <div v-show="show" class="pre-export-component-template">
    <div class="bro-check-body">
      <p class="bro-check-header">{{ $t('preExport.BROSADIdCheck.label.broData') }}</p>
      <p class="bro-check-explanation">{{ $t('preExport.BROSADIdCheck.label.broExplanation') }}</p>
      <div class="bro-check-content">
        <div class="terraindex-bro-id">
          <label>{{ $t('preExport.BROSADIdCheck.label.broIdTerraIndex') }}</label>
          <div class="terraindex-bro-id-input">
            <i v-if="validatedBROID !== projectBROID" class="fa-regular fa-triangle-exclamation warning" />
            <i v-if="validatedBROID === projectBROID && projectBROID" class="fa-regular fa-circle-check success" />
            <input type="text" :value="projectBROID" disabled />
          </div>
        </div>

        <button type="button" class="sync-button primary-button" :disabled="validatedBROID === projectBROID" @click="storeBROID()">
          <i class="fa-regular fa-left-to-bracket"></i>
          {{ $t('preExport.BROSADIdCheck.label.takeOver') }}
        </button>

        <div class="broservice-bro-id">
          <label>{{ $t('preExport.BROSADIdCheck.label.broIdPortal') }}</label>
          <input type="text" :value="validatedBROID" disabled />
        </div>
      </div>

      <p v-if="!projectBROID && !validatedBROID" class="bro-check-action-message">{{ actionMessage }}</p>
      <p v-else-if="validatedBROID === projectBROID && projectBROID" class="bro-check-action-message success">{{ actionMessage }}</p>
      <p v-else class="bro-check-action-message warning">{{ actionMessage }}</p>
    </div>
  </div>
</template>

<script>
import '@/assets/less/colors.less'
import { BROService } from '@/services/BROService/BROService'
import stringUtils from '@/utils/stringUtils'

export default {
  name: 'BROSADIdCheck',
  props: {
    projectId: {
      type: String,
      required: true
    }
  },
  components: {
  },
  data() {
    return {
      BROService: new BROService(),
      actionMessage: '',
      projectBROID: null,
      validatedBROID: null,
      defaultBroIdRequirement: 'Undefined',
      selectedBroIdRequirement: this.defaultBroIdRequirement,
      show: true
    }
  },
  mounted() {
    this.projectBROID = this.$store?.state?.currentProject?.BroId
    this.BROService.getBROID(this.$store?.state?.currentProject?.PrGuid).then(response => {
      this.validatedBROID = response[0]?.broId

      this.updateValidationMessage()
      this.updateSelectedBroIdRequirement()
    })
    this.$emit('preExportCheckUpdated')
  },
  computed: {
    getExportProjects() {
      return this.$store.getters.getExportInformationExportProjects
    }
  },
  methods: {
    async storeBROID() {
      this.$store.state.currentProject.BroId = this.validatedBROID || ''

      await this.$store.dispatch('setProject', { projectData: this.$store.state.currentProject }).then(result => {
        this.projectBROID = result.BroId
        this.updateValidationMessage()
        this.updateSelectedBroIdRequirement()
      })

      await this.$store.dispatch('setCurrentProject', this.$store.state.currentProject)
    },
    updateValidationMessage() {
      const projectBROIDSpecified = stringUtils.isNullOrEmptyOrWhitespace(this.projectBROID) === false
      const validatedBROIDSpecified = stringUtils.isNullOrEmptyOrWhitespace(this.validatedBROID) === false

      if (!projectBROIDSpecified && !validatedBROIDSpecified) {
        this.actionMessage = this.$t('preExport.BROSADIdCheck.messages.broIdNotFound')
        this.selectedBroIdRequirement = 'Registration'
      } else if (projectBROIDSpecified && !validatedBROIDSpecified) {
        this.actionMessage = this.$t('preExport.BROSADIdCheck.messages.broIdMismatch')
        this.selectedBroIdRequirement = this.defaultBroIdRequirement
      } else if (!projectBROIDSpecified && validatedBROIDSpecified) {
        this.actionMessage = this.$t('preExport.BROSADIdCheck.messages.broIdMismatch')
        this.selectedBroIdRequirement = this.defaultBroIdRequirement
      } else if (this.projectBROID !== this.validatedBROID) {
        this.actionMessage = this.$t('preExport.BROSADIdCheck.messages.broIdMismatch')
        this.selectedBroIdRequirement = this.defaultBroIdRequirement
      } else if (this.projectBROID === this.validatedBROID) {
        this.actionMessage = this.$t('preExport.BROSADIdCheck.messages.broIdMatch')
        this.selectedBroIdRequirement = 'Correction'
      }
    },
    updateSelectedBroIdRequirement() {
      this.$store.commit('updateExportProjectConversionContext', { PrID: this.projectId, conversionContext: { broIdRequirement: this.selectedBroIdRequirement } })
    }
  }
}
</script>

<style lang="less" scoped>
.pre-export-component-template {
  background: @gray100;
  padding: 16px;
}

.terraindex-bro-id {
  display: flex;
  flex-direction: column;
  .terraindex-bro-id-input {
    position: relative;
    i {
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  input {
    display: flex;
    padding: 12px;
    padding-left: 28px;
    border-radius: 4px;
    border: 1px solid @gray400;
    background: @gray50;
  }
}
.sync-button {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 24px;
  padding: 12px 20px;
  border-radius: 4px;
  border: 1px solid #9DA3AD;
  background: @white;
}
.sync-button:disabled {
  border: 1px solid @gray200;
  color: @gray300;
}
.broservice-bro-id {
  display: flex;
  flex-direction: column;
  input {
    padding: 12px;
    border-radius: 4px;
    border: 1px dashed @gray300;
    background: @gray50;
  }
}
.bro-check-action-message {
  margin-top: 6px;
  font-size: 14px;
  line-height: 20px;
  color: @gray500;
}
.success {
  color: @primaryGreen;
}
.warning {
  color: @warning600;
}
</style>
